import React from 'react'
import { withStyles, Menu, MenuItem } from '@material-ui/core'

export const StyledMenu = withStyles((theme) => ({
  paper: {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[4], // shadow-xl 
    borderRadius: '16px',
    minWidth: '240px',
    padding: '8px',
    backgroundColor: theme.palette.background.paper,
  },
}))((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    {...props}
  />
))

export const StyledMenuItem = withStyles((theme) => ({
  root: {
    padding: '10px 16px',
    borderRadius: '10px',
    margin: '4px 0',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover || 'rgba(0, 0, 0, 0.04)',
      transform: 'translateX(4px)',
    },
    '& .MuiListItemIcon-root': {
      minWidth: '44px',
      color: theme.palette.primary.main,
    },
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: '0.875rem',
      color: theme.palette.text.primary,
    },
  },
}))(MenuItem)

export const useStyles = () => ({})

